import HorizontalSelectionBar from "components/apiDocs/BrowseAllPage/HorizontalSelectionBar";
import TagSection from "components/apiDocs/BrowseAllPage/TagSection";
import {
  StyledBody,
  StyledFilteredResultsSection,
} from "components/apiDocs/BrowseAllPage/style";
import { ApiData } from "models/apiDocumentation/apiDocumentationModels";
import React, { useState } from "react";

interface Props {
  apiData: ApiData;
}

const BrowseAllPage: React.FC<Props> = ({ apiData }) => {
  const [selectedTab, setSelectedTab] = useState("All");
  const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
  const tabList: string[] = ["All"].concat(alphabet);

  return (
    <StyledBody>
      <h1>Browse all endpoints</h1>
      <HorizontalSelectionBar
        tabList={tabList}
        selectedTab={selectedTab}
        setSelectedTab={setSelectedTab}
        apiData={apiData}
      />
      <StyledFilteredResultsSection>
        {apiData.tags
          .filter(
            (tag) => tag.name.startsWith(selectedTab) || selectedTab === "All"
          )
          .map((tag, index) => (
            <TagSection key={index} tag={tag} apiData={apiData} />
          ))}
      </StyledFilteredResultsSection>
    </StyledBody>
  );
};
export default BrowseAllPage;
